export function arrowScroller(element: Element): void {
  const nextSection = element.closest('section')?.nextElementSibling
  const header = document.querySelector('header')

  element.addEventListener('click', () => {
    if (window.lenis) {
      window.lenis.scrollTo(nextSection)
    } else {
      window.scrollTo({
        top: nextSection?.offsetTop - header?.offsetHeight,
        behavior: 'smooth'
      })
    }
  })
}
